import { useEffect, useState } from "react";
import useDataBean from "../../../../../../core/services/dataBean/useDataBean";
import { _EmployeeContractHistory, _single } from "../../../../../../core/services/dataBean/EntityCatalog";
import { Singleton } from "../../../../../../core/services/Singleton";
import { ListMenu } from "../../../../../theme/Component/ListMenu";
import { BasicTable, MASK_DATE, MASK_MONEY, MASK_NUMBER } from "../../../../../theme/Component/BasicTable";
import { Modal } from "../../../../../theme/Component/Modal";
import { InputDate } from "../../../../../theme/Input/InputDate";
import { AppointmentEditor } from "../../../../ParametrosTalentoHumano/Appointment/Appointment.editor";
import useModal, { MODAL_md, MODAL_SM } from "../../../../../theme/Component/hooks/useModal";
import { toast } from "react-toastify";
import { InputMoney } from "../../../../../theme/Input/InputMoney";
import { SelectFunctionalArea } from "../../../../../admin/configuracion/FunctionalArea/SelectFunctionalArea";
import { AppointmentCatalog } from "../../../../ParametrosTalentoHumano/Appointment/AppointmentCatalog/AppointmentCatalog";


interface PropAbility {
    _IDContract: number;
}

export const ContractHistory = ({ _IDContract }: PropAbility) => {

    const { instance, setBean, bean, lista, setLista } = useDataBean(_EmployeeContractHistory);
    const single = Singleton.getInstance();

    const modalNivelSalary = useModal("Actualizar Nivel Salarial", MODAL_md);
    const modalArea = useModal("Actualizar Nivel Salarial", MODAL_md);
    const modalSalary = useModal("Actualizar Nivel Salarial", MODAL_md);
    const modalDelete = useModal("Eliminar Historia Laboral", MODAL_SM);

    useEffect(() => {
        if (_IDContract >= 0) {
            getLista();
        }
    }, [_IDContract])

    const getLista = () => {
        setBean({});
        instance.getEmployeeContractHistoryCatalog(_IDContract).then(
            (resp) => {
                //console.log(resp)
                setLista(resp)
            }
        )
    }

    const updateSalary = () => {
        instance.setSalaryForEmployeeContractHistory(bean.IDContractHistory, bean.LastSalary, _single.getAccountID()).then(
            (resp) => {
                modalSalary.close();
                getLista();
            }
        ).catch(err => { toast.error(err) })
    }

    const updateAppointment = () => {
        instance.setAppointmentForEmployeeContractHistory(bean.IDContractHistory, bean.IDAppointment, single.getAccountID()).then(
            (resp) => {
                getLista();
                modalNivelSalary.close();
            }
        ).catch(err => { toast.error(err) })
    }

    const updateArea = () => {
        instance.setFunctionalAreaForEmployeeContractHistory(bean.IDContractHistory, bean.IDLnFunctionalArea, single.getAccountID()).then(
            (resp) => {
                getLista();
                modalArea.close();
            }
        ).catch(err => { toast.error(err) })
    }

    const deleteHistory = () => {
        instance.deleteEmployeeContractHistory(bean.IDContractHistory, single.getAccountID()).then(
            (resp) => {
                getLista();
                modalDelete.close();
            }
        ).catch(err => { toast.error(err) })
    }

    const head = [
        { title: 'ID', property: 'IDContractHistory', mask: MASK_NUMBER, visible: true },
        { title: 'ID Plaza Laboral', property: 'IDLnFunctionalArea', mask: MASK_NUMBER, visible: true },
        { title: 'Plaza Laboral', property: 'FunctionalAreaName', visible: true },
        { title: 'Código Posición Jerárquica', property: 'FunctionalIDJsonCode', visible: true },
        { title: 'Nombre Posición Jerárquica', property: 'FunctionalIDName', visible: true },
        { title: 'Fecha Inicial', property: 'InitDate', mask: MASK_DATE, visible: true },
        { title: 'Fecha Final', property: 'UptoDate', mask: MASK_DATE, visible: true },
        { title: 'Nivel Salarial', property: 'AppointmentName', visible: true },
        { title: 'Nivel Jerárquico', property: 'EntailmentName', visible: true },
        { title: 'Salario', property: 'LastSalary', mask: MASK_MONEY, visible: true },
        // { title: 'Es Cambio de Asignación', property: 'IsAppointmentChange', visible: true },
        { title: 'Actualizado por', property: 'LastUpdateEmployeeName', visible: true },

    ]

    const listaBotones = () => {
        const botones = [
            { titulo: 'Actualizar Nivel Salarial', icono: 'ri-edit-2-line', visible: single.canEdit(), evento: () => { modalNivelSalary.open() } },
            { titulo: 'Actualizar Plaza Laboral', icono: 'ri-swap-box-line', visible: single.canDelete(), evento: () => { modalArea.open() } },
            { titulo: 'Actualizar Salario', icono: 'ri-file-edit-line', visible: single.canDelete(), evento: () => { modalSalary.open() } },
            { titulo: 'Eliminar Historia Laboral', icono: 'ri-delete-bin-line', visible: single.canDelete(), evento: () => { modalDelete.open() } },
        ]
        return (
            <ListMenu listaBotones={botones} />
        )
    }

    return (
        <div className="row">
            <div className="col-12">
                <BasicTable listButtons={listaBotones()} head={head} body={lista} rowSet={(history) => { setBean(history) }} />

                <Modal modal={modalNivelSalary.modal} updateModal={modalNivelSalary.setModal} eventModal={() => { updateAppointment() }}>
                    <div className="row">
                        <div className="col-12">
                            <label>Nivel Salarial</label>
                            <AppointmentCatalog render={bean.Name} idSelector={bean.IDAppointment} onChange={(e) => { setBean({ ...bean, "IDAppointment": e.IDAppointment, "Name": e.Name }) }} label=" " returnType="Object" />
                            {/* <AppointmentEditor label="Nivel Salarial" idSelector={bean.IDAppointment} onChange={(e) => { setBean({ ...bean, "IDAppointment": e }) }} /> */}
                        </div>
                    </div>
                </Modal>

                <Modal modal={modalSalary.modal} updateModal={modalSalary.setModal} eventModal={() => { updateSalary() }} >
                    <div className="row">
                        <div className="col-12">
                            <label>Valor del Salario</label>
                            <InputMoney _value={bean.LastSalary} onChange={(e) => { setBean({ ...bean, "LastSalary": e }) }} _label=" " />
                        </div>
                    </div>
                </Modal>
                <Modal modal={modalArea.modal} updateModal={modalArea.setModal} eventModal={() => { updateArea() }} >
                    <div className="row">
                        <div className="col-12">
                            <label>Plaza Laboral</label>
                            <SelectFunctionalArea label=" " onChange={(e) => { setBean({ ...bean, "IDLnFunctionalArea": e.IDLn }) }} />
                        </div>
                    </div>
                </Modal>
                <Modal modal={modalDelete.modal} updateModal={modalDelete.setModal} eventModal={() => { deleteHistory() }} >
                    <p>¿Continuar con la eliminacion de {bean.IDContractHistory} - {bean.FunctionalAreaName} ?</p>
                </Modal>
            </div>
        </div>
    )
}